class MSizeChartModal extends HTMLElement {
  constructor() {
    super();
    this.closeButtons = this.querySelectorAll('[data-m-size-chart-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    });
  }

  connectedCallback() {
  
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }
  }

  open() {
    this.hidden = false;
    document.body.classList.add('m-size-chart-modal-open');
  }

  close() {
    this.hidden = true;
    document.body.classList.remove('m-size-chart-modal-open');
  }
}

customElements.define('m-size-chart-modal', MSizeChartModal);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-m-size-chart-open]');
  if (!trigger) return;
  const targetId = trigger.getAttribute('data-m-size-chart-open');
  const modal = document.getElementById(targetId);
  if (modal && typeof modal.open === 'function') modal.open();
});